export const useStyles = (theme) => ({
  root: {
    padding: 10,
  },
  editFormStyle: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
  },
  inputWithMargin: {
    width: "32%",
    marginRight: 10,
    [theme.breakpoints.between(750, 1000)]: {
      width: "48%",
    },
    [theme.breakpoints.down(750)]: {
      width: "100%",
    },
  },
  inputWithoutMargin: {
    width: "49%",
    [theme.breakpoints.down(539)]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    backgroundColor: "#fff",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 16,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  messageLoading: {
    fontSize: 25,
    fontWeight: "bold",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});
